import { driver, DriveStep } from "driver.js";
import "driver.js/dist/driver.css";

export type { DriveStep };

// Step-by-step overlay tutorials. Steps are anchored on `data-tour="…"`
// attributes; steps whose element isn't currently rendered (e.g. sections
// that only appear for saved events) are skipped instead of showing an
// unanchored popover.
export function startTour(steps: DriveStep[]) {
  const visible = steps.filter(
    (s) => !s.element || (typeof s.element === "string" && document.querySelector(s.element)),
  );
  if (visible.length === 0) return;
  driver({
    showProgress: true,
    smoothScroll: true,
    progressText: "{{current}} von {{total}}",
    nextBtnText: "Weiter",
    prevBtnText: "Zurück",
    doneBtnText: "Fertig",
    steps: visible,
  }).drive();
}

// Auto-start once per browser and tour key; storage can be unavailable
// (private mode), in which case the tour just isn't auto-started.
export function startTourOnFirstVisit(key: string, steps: DriveStep[]) {
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch {
    return;
  }
  startTour(steps);
}
